
<template>
  <div>
  <div class="cntnt" >

<div id="terms">

    <h1 class="heading">  ৱেবচাইটৰ চৰ্তাৱলী আৰু নিয়মাৱলী</h1>
    <p class="content">
      সাধাৰণ ৰাইজক তথ্য প্ৰদান কৰাৰ বাবে অসম শক্তি বিতৰণ কোম্পানী লিমিটেডৰ (এপিডিচিএল) অফিচিয়েল ৱেবছাইট টো বিকশিত আৰু আয়োজন কৰা হৈছে।
     এই ৱেবছাইটত প্ৰদৰ্শিত নথিপত্ৰ আৰু তথ্য কেৱল প্ৰসংগৰ উদ্দেশ্যৰ বাবে আৰু ই এক আইনী দস্তাবেজ নহয়।
  <br><br>
  যদিও এই ৱেবছাইটত সমলৰ শুদ্ধতা নিশ্চিত কৰাৰ বাবে সকলো প্ৰচেষ্টা কৰা হৈছে, ইয়াক আইনৰ বিবৃতি হিচাপে গণ্য কৰিব নালাগে বা কোনো আইনী উদ্দেশ্যৰ
   বাবে ব্যৱহাৰ কৰিব নালাগে। যিকোনো অস্পষ্টতা বা সন্দেহৰ ক্ষেত্ৰত, ব্যৱহাৰকাৰীসকলক কোম্পানী আৰু/বা আন উৎসৰ সৈতে য'ত প্ৰযোজ্য হয় পৰীক্ষা/পৰীক্ষা কৰিবলৈ
    পৰামৰ্শ দিয়া হয় যাতে উপযুক্ত তথ্য প্ৰাপ্ত কৰিব পাৰি।
  <br><br>
  ৱেবছাইটত উল্লেখ কৰা কথাবোৰ আৰু প্ৰাসঙ্গিক আইন, নিয়মাৱলী, নীতি বিবৃতি আদিত সন্নিবিষ্ট বোৰৰ মাজত যিকোনো পাৰ্থক্য থাকিলে, পিছৰটো প্ৰাধান্য পাব।
  <br><br>
  ৱেবছাইটৰ যিকোনো অংশত যিকোনো প্ৰশ্ন বা প্ৰশ্নৰ সংহতিৰ যিকোনো নিৰ্দিষ্ট পৰামৰ্শ বা উত্তৰ এনে বিশেষজ্ঞ/পৰামৰ্শদাতা/ব্যক্তিসকলৰ ব্যক্তিগত মতামত আৰু কোম্পানী বা
   ইয়াৰ ৱেবছাইটৰ দ্বাৰা সন্মত হোৱাটো প্ৰয়োজনীয় নহয়।
  <br><br>
  দৰ্শনাৰ্থীৰ সুবিধাৰ বাবে ৰখা ৱেবছাইটৰ কিছুমান লিংকৰ ফলত তৃতীয় পক্ষৰ দ্বাৰা ৰক্ষণাবেক্ষণ কৰা আন ৱেবছাইটত অৱস্থিত সম্পদ ৰখা হয় যাৰ ওপৰত এপিডিচিএলৰ
   কোনো নিয়ন্ত্ৰণ নাই।  এই ৱেবছাইটবোৰ এপিডিচিএলৰ বাহ্যিক। এ.পি.ডি.চি.এল.-য়ে কোনো ধৰণৰ সমৰ্থন নকৰে বা কোনো বিচাৰ বা ৱাৰেণ্টি প্ৰদান নকৰে
    আৰু কোনো সামগ্ৰীৰ সত্যতা, উপলব্ধতাৰ বাবে কোনো দায়বদ্ধতা বা দায়বদ্ধতা স্বীকাৰ নকৰে বা
  সেৱাসমূহ বা যিকোনো ক্ষতি, লোকচান বা ক্ষতি, প্ৰত্যক্ষ বা পৰিণামস্বৰূপ বা স্থানীয় বা আন্তৰ্জাতিক আইনৰ যিকোনো উলংঘনৰ বাবে যাৰ ফলত এই
  বাহ্যিক ৱেবছাইটবোৰ পৰিদৰ্শন বা লেনদেন কৰোঁতে হ'ব পাৰে।
    </p>
  </div>
<br><br><br><br><br><br><br><br><br><br>
<div id="privacy">
  <b-row>
    <b-col cols="6">
        <h1 class="heading">গোপনীয়তা নীতি</h1>
    </b-col>
</b-row>
<p class="content">
  অসম পাৱাৰ ডিষ্ট্ৰিবিউচন কোম্পানী লিমিটেডে (এপিডিচিএল) আমাৰ ৱেবছাইট/অনলাইন সেৱা/ম'বাইল এপ্প ব্যৱহাৰ কৰা ব্যক্তি/উপভোক্তা আৰু যাৰ ৰাজহ বিল/সেৱা
   সংযোগবোৰ আমাৰ ছফ্টৱেৰ এপ্লিকেচন/ম'বাইল এপ্পৰ সৈতে প্ৰক্ৰিয়া কৰা হয় তেওঁলোকৰ গোপনীয়তাক সন্মান আৰু সুৰক্ষা দিয়ে।
  <br><br>
  আপোনাৰ বিষয়ে ব্যক্তিগতভাৱে চিনাক্ত কৰিব পৰা তথ্য প্ৰথমে আপোনাৰ অনুমতি নোপোৱাকৈ কোনো তৃতীয় পক্ষক ইচ্ছাকৃতভাৱে প্ৰকাশ কৰা নহয়,
  এই গোপনীয়তা নীতিত ("গোপনীয়তা নীতি") বৰ্ণনা কৰা অনুসৰি।
  বেছিভাগ ব্ৰাউজাৰ প্ৰথমতে কুকিগ্ৰহণ কৰিবলৈ ছেট আপ কৰা হয়। আপুনি সকলো কুকি অস্বীকাৰ কৰিবলৈ বা কুকি কেতিয়া প্ৰেৰণ কৰা হৈছে সূচিত
   কৰিবলৈ আপোনাৰ ব্ৰাউজাৰ ৰিছেট কৰিব পাৰে। অৱশ্যে, সতৰ্ক হ'ব যে যদি আপুনি কুকিজ অস্বীকাৰ কৰে তেন্তে আমাৰ সেৱাৰ কিছুমান অংশসঠিকভাৱে কাম নকৰিব পাৰে।
  <br><br>
  আপুনি যেতিয়া বিশেষভাৱে আৰু জ্ঞাতভাৱে এনে তথ্য প্ৰদান কৰে, আমি আপোনাৰ বিষয়ে কোনো অনন্য তথ্য সংগ্ৰহ নকৰোঁ
(যেনে আপোনাৰ নাম, ইমেইল ঠিকনা, ম'বাইল নম্বৰ ইত্যাদি)। আমি অৱশ্যে দ্ৰুত ফিউজ কল সেৱা প্ৰদান কৰাৰ বাবে আপোনাৰ চৌহদৰ জিপিএছ স্থানাংক সংগ্ৰহ কৰিব পাৰোঁ।
  <br><br>
  এই ৱেবছাইটটো ব্যৱহাৰ কৰিবলৈ সন্মত হৈ, আপুনি আপোনাৰ উপভোক্তা নম্বৰ বা এপিডিচিএলৰ পৰা অন্যান্য সাধাৰণ উপভোক্তা তথ্য/ঘোষণাৰ সন্দৰ্ভত
  এপিডিচিএলৰ পৰা ইমেইল/এছএমএছ যোগাযোগ প্ৰাপ্ত কৰিবলৈও সন্মত হৈছে।

এ.পি.ডি.চি.এল.-য়ে আপোনাৰ স্পষ্ট সন্মতি অবিহনে বিজ্ঞাপনদাতা, পৃষ্ঠপোষক আৰু অন্যান্য তৃতীয় পক্ষৰ সৈতে আপোনাৰ ব্যক্তিগত তথ্য ভাগ-বতৰা নকৰিব।

অনুগ্ৰহ কৰি অৱগত হ'ব যে যিকোনো বৈধ আইনী প্ৰক্ৰিয়া যেনে অনুসন্ধান ৱাৰেণ্ট, আদালতৰ আদেশ আদি পালন কৰাৰ বাবে যদি প্ৰয়োজন হয় তেন্তে আমি
আপোনাৰ বিষয়ে নিৰ্দিষ্ট ব্যক্তিগত তথ্য মুকলি কৰিম।
  <br><br>
  www.apdcl.org ব্যৱহাৰ কৰি আৰু আমাৰ ই-সেৱাসমূহ প্ৰাপ্ত কৰি, আপুনি এই আঁচনিত আমি উল্লেখ কৰা অনুসৰি আপোনাৰ তথ্য সংগ্ৰহ আৰু ব্যৱহাৰ ৰ
   বাবে সন্মতি প্ৰদান কৰে আৰু আমাৰ চৰ্তাৱলী আৰু নিয়মাৱলীলৈ।

 এ.পি.ডি.চি.এল.-য়ে সময়ে সময়ে এই গোপনীয়তা নীতি সলনি কৰাৰ সিদ্ধান্ত ল'ব পাৰে। যেতিয়া আমি কৰোঁ, আমি পোষ্ট কৰিম
 এই পৃষ্ঠাত সেই পৰিৱৰ্তনবোৰ যাতে আমি সংগ্ৰহ কৰা তথ্য, আমি ইয়াক কেনেদৰে ব্যৱহাৰ কৰোঁ, আৰু কি পৰিস্থিতিত আমি ইয়াক প্ৰকাশ কৰোঁ সেই বিষয়ে
  আপুনি সদায়ে অৱগত থাকে।
</p>
</div>
<br><br><br><br><br><br><br><br><br><br>
<div id="copyright">
  <b-row>
    <b-col cols="6">
      <h1 class="heading">স্বত্বাধিকাৰ নীতি</h1>
    </b-col>

 </b-row>

<p class="content">
  এই ৱেবছাইটত থকা সামগ্ৰীবোৰ ৰাজহুৱা ক্ষেত্ৰত আছে আৰু সেয়েহে পৰিৱৰ্তন অবিহনে যিকোনো ফৰ্মেট বা মিডিয়াত পুনৰ প্ৰস্তুত কৰা হ'ব
  পাৰে আৰু কোনো নিৰ্দিষ্ট অনুমতিৰ প্ৰয়োজন নহ'ব।

  এইটো চৰ্ত সাপেক্ষে যে সামগ্ৰীবোৰ সঠিকভাৱে পুনৰ প্ৰস্তুত কৰা হ'ব আৰু কোনো অপমানজনক ধৰণে বা বিভ্ৰান্তিকৰ পৰিপ্ৰেক্ষিতত নহয়।

  য'ত সামগ্ৰীটো প্ৰকাশ কৰা হৈছে বা আনক জাৰী কৰা হৈছে, উৎসটো গুৰুত্বপূৰ্ণভাৱে স্বীকাৰ কৰিব লাগিব।

  সামগ্ৰী পুনৰুৎপাদন কৰাৰ অনুমতিত এই ছাইটত থকা যিকোনো সামগ্ৰী বাদ দিয়া হয় যি তৃতীয় পক্ষৰ কপিৰাইট উলংঘন কৰিব পাৰে/হ'ব পাৰে।
  এনে সামগ্ৰী পুনৰুৎপাদন কৰাৰ অনুমোদন সংশ্লিষ্ট কপিৰাইট ধাৰকৰ পৰা আগতীয়াকৈ প্ৰাপ্ত কৰিব লাগিব।
</p>
</div>
<br><br><br><br><br><br><br><br><br><br>
<div id="hyperlink">
  <b-row>
    <b-col cols="6">
    <h1 class="heading">হাইপাৰলিংক নীতি</h1>
    </b-col>

 </b-row>

 <p class="content">
   নীতিৰ বিষয় হিচাপে আমাৰ ছাইটত হস্ট কৰা তথ্যৰ সৈতে কোনো পোনপটীয়া সংযোগত আমাৰ কোনো আপত্তি নাই আৰু ইয়াৰ বাবে কোনো আগতীয়া
    অনুমতিৰ প্ৰয়োজন নাই। অৱশ্যে পৰিৱৰ্তন ৰ ক্ষেত্ৰত বা য'ত প্ৰয়োজন হয় তাত উন্নীতকৰণৰ সুবিধাৰ বাবে আমাৰ ছাইটত প্ৰদান কৰা যিকোনো লিংকৰ
    বিষয়ে আমাক অৱগত কৰিব বিচাৰো।

লগতে, আমি আমাৰ পৃষ্ঠাবোৰ পোনপটীয়াকৈ আন এটা ছাইটত ফ্ৰেমত লোড কৰিবলৈ অনুমতি নিদিওঁ। আমাৰ কোম্পানীৰ পৃষ্ঠা/পৃষ্ঠাবোৰ ডিফল্টভাৱে ব্যৱহাৰকাৰীৰ
এটা নতুন ব্ৰাউজাৰ উইণ্ডোত অৱতৰণ/লোড কৰিব লাগিব।
   <br><br>
   এই পৰ্টেলৰ বহুতো স্থানত, দৰ্শনাৰ্থীসকলে আন ৱেবছাইট/পৰ্টেলৰ লিংক বিচাৰি পাব পাৰে, এই লিংকবোৰ তেওঁলোকৰ সুবিধাৰ বাবে ৰখা হৈছে।

এই সংযোজিত ৱেবছাইট/পৰ্টেলবোৰৰ সমল আৰু নিৰ্ভৰযোগ্যতাৰ বাবে এপিডিচিএল দায়বদ্ধ নহয় আৰু ইয়াত প্ৰকাশ কৰা মতামতবোৰ অপৰিহাৰ্যভাৱে সমৰ্থন নকৰে।

এই পৰ্টেলত কেৱল লিংক(বোৰ) বা ইয়াৰ তালিকাভুক্তিকোনো ধৰণৰ অনুমোদন হিচাপে ধৰি ল'ব নালাগে।

আমি নিশ্চয়তা দিব নোৱাৰো যে এই লিংকবোৰে সকলো সময়তে কাম কৰিব কিয়নো এনে লিংকৰ উপলব্ধতাৰ ওপৰত আমাৰ কোনো নিয়ন্ত্ৰণ নাই।

যদি এনে কোনো মৃত লিংক(বোৰ)/ভঙা লিংকৰ বিষয়ে তথ্য আমাৰ দৃষ্টিগোচৰ কৰা হয় যাতে আমি উপযুক্ত পদক্ষেপ ল'বলৈ সক্ষম হওঁ তেনেহ'লে ইয়াক যথেষ্ট প্ৰশংসা কৰা হ'ব।
 </p>
</div>
<br><br><br><br><br><br><br><br><br><br>
<div id="disclaimer">
  <b-row>
    <b-col cols="6">
      <h1 class="heading">অস্বীকৃত</h1>
    </b-col>

 </b-row>
 <p class="content">
   যদিও এই ৱেবছাইটত প্ৰদান কৰা তথ্যৰ শুদ্ধতা নিশ্চিত কৰাৰ বাবে প্ৰতিটো যত্ন লোৱা হৈছে, এই তথ্যৰ আধাৰত লোৱা যিকোনো পদক্ষেপৰ ফলাফলৰ বাবে
   এপিডিচিএল-এ কোনো ব্যক্তিৰ কোনো ক্ষতি বা ক্ষতিৰ বাবে কোনো দায়বদ্ধতা বা দায়বদ্ধতা স্বীকাৰ নকৰে। অৱশ্যে, পৰৱৰ্তী আপডেটত সংশোধন কৰাৰ বাবে
   ত্ৰুটি/ভুলবোৰ ইয়াৰ দৃষ্টিগোচৰ হ'লে এ.পি.ডি.চি.এল. বাধ্য হ'ব।

যেতিয়া ব্যৱহাৰকাৰীসকলে বাহিৰৰ ৱেবছাইটএটাৰ লিংক এটা অনুসৰণ কৰে, তেওঁলোকে এপিডিচিএল ছাইট এৰি যায় আৰু বাহিৰৰ ৱেবছাইটৰ গোপনীয়তা আৰু সুৰক্ষা নীতিসাপেক্ষে।
 </p>
</div>
<br><br><br><br><br><br><br><br><br><br>

</div>
</div>
</template>

<style scoped="true">
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;

}
.content{
    text-align: justify;
line-height: 1.8rem;
font-size:0.9rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;


}
#vision{
  transition: 1s;
}
table{
  text-align: left !important;
}
</style>
<script>
export default {
data() {
  return {
    KeyOfficial: [
      { Name: 'Shri Vinod Kumar Pipersenia, IAS (Retd.)', Designation: 'Chairman, APDCL	', Phone: '0361-2739528(O), 0361-2739527 (F)', Mobile: 'NA', Email: 'asebchairman@gmail.com'},
      { Name: 'Shri Niraj Verma, IAS', Designation: 'Principal Secretary, Power(E)', Phone: 'NA', Mobile: 'NA', Email: 'NA'},
      { Name: 'Shri Rakesh Agarwala, IAS', Designation: 'Managing Director, APDCL', Phone: '0361-2739516 (O)', Mobile: 'NA', Email: 'md.apdcl@apdcl.org'},
      { Name: 'Shri Abhijit Sarma Barua	', Designation: 'CGM (CR)', Phone: '	0361-2739521 (O)', Mobile: '9864102725', Email: 'cgm.crapdcl@gmail.com'},
      { Name: 'Shri Dipak Kr. Sarmah', Designation: 'CGM (D&S), LAR', Phone: '0361-2739509 (O)', Mobile: '9435396852', Email: 'cgmlarapdcl@gmail.com'},
      { Name: 'Shri Krishnananda Saikia	', Designation: 'CGM (D&S), CAR	', Phone: '0361-2739512 (O),0361-2739539 (F)', Mobile: '9954071956', Email: 'cgmdapdclcaz@yahoo.com'},
      { Name: 'Shri Dipankar Nath', Designation: 'CGM (D&S), UAR', Phone: '0361-2739532 (O)', Mobile: '9435170970', Email: 'chiefengineer_uaedcl@yahoo.com'},
      { Name: 'Shri Dhrubajyoti Hazarika', Designation: 'CGM (RE)', Phone: '0361-2735684 (O), 0361-2739626 (F)', Mobile: '9101806117', Email: 'cgmre.aseb@gmail.com'},
      { Name: 'Shri Nirmaljit Das	', Designation: 'CGM (PP&D)	', Phone: '0361-2739514 (O)', Mobile: '9435114066', Email: 'cgmppdapdcl@yahoo.com'},
      { Name: 'Shri Manoranjan Kalita	', Designation: 'CGM (Com. & E.E.)	', Phone: '0361-2739515 (O)	', Mobile: '9435137602	', Email: 'acecomt.aseb@gmail.com'},
      { Name: 'Shri Biswajit Kar	', Designation: 'CGM (HRA)	', Phone: '0361-2739507 (O)	', Mobile: 'NA', Email: 'cgmhraapdcl@yahoo.com'},
      { Name: 'Shri Manish Dasgupta	', Designation: 'CGM (F&A)	', Phone: '0361-2739511 (O)	', Mobile: '9864208641', Email: 'fin.apdcl2009@gmail.com, cgmf.apdcl2012@gmail.com'},
      { Name: 'Shri Deepak Kr. Das	', Designation: 'Director (PMU)	', Phone: '0361-2607533 (O)	', Mobile: '9864064649', Email: 'pmu_aseb@rediffmail.com'}
    ],

    ZoneContact: [
      { Name: 'Guwahati Zone', Contact_Person: 'Shri Partha Pratim Sarmah		',  Mobile: '9864050777', Email: 'gm.laz@apdcl.org,gm_gz@rediffmail.com'},
      { Name: 'Rangia Zone', Contact_Person: 'Smt. Nafiza Borbora	',  Mobile: '9435009537', Email: 'gmrangiazone@gmail.com'},
      { Name: 'Bongaigaon Zone', Contact_Person: 'Shri Jibeswar Das',  Mobile: '9435121248', Email: 'gm.bongaigaon@gmail.com'},
      { Name: 'Tezpur Zone', Contact_Person: 'Shri Bhaskar Jyoti Bora',  Mobile: '7086017970', Email: 'gm.naz@apdcl.org,gmnaztez@gmail.com'},
      { Name: 'Nagaon Zone', Contact_Person: 'Shri Dhruba Bora',  Mobile: '7002899369', Email: 'gmnezapdcl@gmail.com'},
      { Name: 'Silchar Zone', Contact_Person: 'Shri Krishnendu Nath',  Mobile: '9435073549', Email: 'gm.bvz@apdcl.org,gmsz.apdcl@gmail.com'},
      { Name: 'Dibrugarh Zone', Contact_Person: 'Shri Anirban Roy',  Mobile: '9435301799', Email: 'gmdbrapdcl@gmail.com'},
      { Name: 'Jorhat Zone', Contact_Person: 'Shri Debajyoti Das',  Mobile: '9864035124', Email: 'gm.uaz@apdcl.org,gmuaedcl@yahoo.co.in'}
    ],
    CircleContact: [
      { Name: 'Guwahati ', Contact_Person: 'Shri Partha Pratim Sarmah		',  Mobile: '9864050777', Email: 'gm.laz@apdcl.org,gm_gz@rediffmail.com'},
      { Name: 'Rangia ', Contact_Person: 'Smt. Nafiza Borbora	',  Mobile: '9435009537', Email: 'gmrangiazone@gmail.com'}
    ],
    DivisionContact: [
      { Name: 'Guwahati ', Contact_Person: 'Shri Partha Pratim Sarmah		',  Mobile: '9864050777', Email: 'gm.laz@apdcl.org,gm_gz@rediffmail.com'},
      { Name: 'Rangia ', Contact_Person: 'Smt. Nafiza Borbora	',  Mobile: '9435009537', Email: 'gmrangiazone@gmail.com'}
    ],
    SubContact: [
      { Name: 'Guwahati ', Contact_Person: 'Shri Partha Pratim Sarmah		',  Mobile: '9864050777', Email: 'gm.laz@apdcl.org,gm_gz@rediffmail.com'},
      { Name: 'Rangia ', Contact_Person: 'Smt. Nafiza Borbora	',  Mobile: '9435009537', Email: 'gmrangiazone@gmail.com'}
    ],
    IRCAContact: [
      { Name: 'Guwahati ', Contact_Person: 'Shri Partha Pratim Sarmah		',  Mobile: '9864050777', Email: 'gm.laz@apdcl.org,gm_gz@rediffmail.com'},
      { Name: 'Rangia ', Contact_Person: 'Smt. Nafiza Borbora	',  Mobile: '9435009537', Email: 'gmrangiazone@gmail.com'}
    ],
    TCContact: [
      { Name: 'Guwahati ', Contact_Person: 'Shri Partha Pratim Sarmah		',  Mobile: '9864050777', Email: 'gm.laz@apdcl.org,gm_gz@rediffmail.com'},
      { Name: 'Rangia ', Contact_Person: 'Smt. Nafiza Borbora	',  Mobile: '9435009537', Email: 'gmrangiazone@gmail.com'}
    ]


  }
}
}
</script>
